module.exports = {
    "page.import.historyBox.processed.table.col.failure": "Failure",
    "page.import.importBox.footerTips": "Description updated using Bulk Upload will not be visible inside Lorikeet. Please download the products into excel file to view such descriptions",
    "page.import.tab.history": "Import History",
    "page.import.historyBox.col.created": "Created",
    "page.im.window.prdSearchPlaceholder": "Please input product title",
    "page.im.setting.btn.createUser": "Create a New Full Access User",
    "page.im.setting.current.desc": "from all pages are selected",
    "page.import.historyBox.col.filename": "File Name",
    "page.im.window.label.order": "Order",
    "page.import.footer.button.done": "Done",
    "page.im.setting.action": "Xiaobai Test",
    "page.im.setting.imForm.to": "To",
    "page.im.setting.btn.clear": "Clear selected",
    "page.import.historyBox.processed.table.col.warning": "Warning",
    "page.import.importBox.importButton": "Upload Files",
    "page.import.historyBox.link.download": "Download",
    "page.import.importBox.infos.3": "Encoding format: UTF-8, separator: semicolon",
    "page.import.historyBox.link.downloadErrorReport": "Download Error Report",
    "page.im.setting.imForm.from": "From",
    "page.import.tab.import": "Import",
    "page.import.historyBox.processed.table.col.sucess": "Success",
    "page.import.historyBox.col.progress": "Progress",
    "page.im.window.process.resend": "Resend",
    "page.im.setting.assignment.title": "Assign your primary chat account",
    "page.im.window.label.loading": "Loading",
    "page.import.tab.template": "Template History",
    "page.im.window.draft": "DRAFT",
    "page.im.setting.assignment.subTitle": "Please assign the login that will be in charge of your chat accounts. It will be the only one able to see all your chats if you have multiple users. NOTE once it is submitted this account cannot be changed",
    "page.im.setting.tab1": "User Management",
    "page.import.title": "Import",
    "page.im.window.unread": "Unread",
    "page.im.window.units": "units",
    "page.im.setting.tab2": "Quick Reply",
    "page.im.window.label.message": "Chat",
    "page.import.historyBox.feedback.failed": "Your import is failed",
    "page.import.historyBox.search.filename": "File Name",
    "page.im.window.label.refresh": "Refresh",
    "page.import.historyBox.col.status": "Status",
    "page.im.window.disconnection": "Network disconnection",
    "page.import.importBox.templateTitle": "Download Templates",
    "page.im.setting.confirm": "Are you sure to remove user from this group",
    "page.import.historyBox.col.user": "User",
    "page.im.window.label.total": "Total",
    "page.im.setting.btn.addUser": "Add User",
    "page.im.window.oversize": "The file is too large to upload(smaller than 50M)",
    "page.import.import": "Import",
    "page.im.window.send": "Send",
    "page.import.historyBox.search.action": "Action",
    "page.im.window.read": "Read",
    "page.im.window.label.status": "Status",
    "page.im.window.label.totalItems": "Total items",
    "page.im.window.label.emptyMessage": "There is no message received.",
    "page.import.importBox.importModeText": "Import Mode",
    "page.import.importBox.infos.1": "To create or upload products you can use CSV files (.csv) or MS Excel documents (.xlsx).",
    "page.im.setting.btn.remove": "Remove",
    "page.import.historyBox.col.processed": "Processed",
    "page.im.setting.tab3": "Auto Reply",
    "page.import.historyBox.feedback.success": "Your import is finished",
    "page.im.setting.btn.selectAll": "from all pages",
    "page.import.importBox.infos.2": "Note: the Excel file may not contain any formulas or references.",
    "page.import.historyBox.col.action": "Action",
    "page.im.window.orderSearchPlaceholder": "Please input order number",
    "page.im.setting.assignment.placeholder": "Email, User Name",
    "page.import.historyBox.col.type": "File Name",
    "page.im.setting.init.confirm": "Once assigned, the Primary Chat Account cannot be edited or delete. Please make sure you have submitted the correct account.",
    "page.im.window.label.emptyList": "Oh no, the buyer hasn't purchased anything from your shop yet.",
    "page.im.window.date.yesterday": "yesterday",
    "page.import.footer.button.another": "Import Another",
    "page.im.setting.title": "Chat Settings",
    "page.im.window.view": "View",
    "page.im.window.label.orderTime": "Order time",
    "page.import.historyBox.search.user": "User",
    "page.im.setting.management.title": "Customer Support"
};